<template>
  <div class="col-sm-12 nopads">
    <b-row>
      <div class="col-sm-4 nopads pr-2">
        <b-form-select
                id="roleId"
                v-model="roleId"
                size="sm"
                class="m1-3"
        >
          <template slot="first">
            <option
                    :value="-1"
                    disabled
            >
              {{ $t('user.select_profile') }}
            </option>
          </template>
          <option
                  v-for="r in roles"
                  :key="r.id"
                  :value="r.id"
          >
            {{ getRoleName(r.role) }}
          </option>
        </b-form-select>
      </div>
      <div class="col-sm-6 nopads">
        <b-form-select
                id="organizationId"
                v-model="organizationId"
                size="sm"
                class="mb-1"
        >
          <template slot="first">
            <option
                    :value="-1"
                    disabled
            >
              {{ $t('user.select_org') }}
            </option>
            <option
                    v-for="c in organizations"
                    :key="c.id"
                    :value="c.id"
            >
              {{ c.name }}
            </option>
          </template>
        </b-form-select>
      </div>
      <div class="col-sm-2 nopads pl-2">
        <b-button
                v-if="userRightUpdate.id < 1"
                size="sm"
                variant="success"
                class="mr-1"
                @click.stop="addUserRight"
                :disabled="roleId < 0 || organizationId < 0"
        >
          <i class="fa fa-plus" />
        </b-button>
      </div>
    </b-row>
  </div>
</template>

<script>
  import {userHelper} from '../../mixins/UserMixin'

  export default {
    name: 'user-right-selector',
    mixins: [userHelper],
    props: {
      organizations: {
        type: Array,
        default: function () { return [] }
      },
      roles: {
        type: Array,
        default: function () { return [] }
      },
      userRight: {
        type: Object,
        default: null
      }
    },
    data: function () {
      return {
        userRightUpdate: {id: -1, role: {id: -1}, organization: {id: -1}},
        roleId: -1,
        organizationId: -1
      }
    },

    mounted() {
      if (this.userRight) {
        this.userRightUpdate = this.userRight
        this.roleId = this.userRightUpdate.role.id
        this.organizationId = this.userRightUpdate.organization.id
      }
    },

    methods: {
      addUserRight: function () {
        this.userRightUpdate.role = this.roles.find(item => item.id === this.roleId)
        this.userRightUpdate.organization = this.organizations.find(item => item.id === this.organizationId)
        this.$emit('addUserRight', this.userRightUpdate)
      },
      reset: function() {
        this.userRightUpdate = {id: -1, role: {id: -1}, organization: {id: -1}}
      }
    }
  }
</script>
